import { useCallback, useEffect, useState } from "react";
import DashboardGreeting from "../DashboardGreeting";
import SearchIcon from "../../assets/images/search.svg";
import FilterIcon from "../../assets/images/filter.svg";
import ExportIcon from "../../assets/images/export.svg";
import { useStateContext } from "../../contexts/ContextProvider";
import { Link } from "react-router-dom";
import DataTableComponent from "../Charts/DatatableComponent";
import ProbationCircle from "../../assets/images/probationCircle.svg";
import FullTimeCircle from "../../assets/images/fullTimeCircle.svg";
import EmployeeFilterModal from "../common/EmployeeFilterModal";
import UploadEmployee from "./UploadEmployee";

import { ToastContainer } from "react-toastify";
import LeaveHistoryService from "../../services/leaveHistory.service";
import moment from "moment";

import * as XLSX from "xlsx";
import { Table } from "antd";

const Employees = ({ user }) => {
  const navHeading =
    user.role === "1" || user.role === "4" ? "Employee" : "Team";

  const { filterBy, setFilterBy, showCalendar, setShowCalendar } =
    useStateContext();

  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);

  const [newEmployeeModal, setNewEmployeeModal] = useState(false);

  const initialData = {
    date: "",
    formatedDate: "Choose",
    empId: "",
    email: "",
    phone: "",
    leaveBalance: "",
    isProbation: "",
    location: "",
    designation: "",
    department: "",
  };

  const [details, setDetails] = useState(initialData);

  const [date, setDate] = useState();

  const [checked, setChecked] = useState("");

  const [members, setMembers] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchAllEmployees = () => {
    const payload = {
      empId: "",
    };

    const payload2 = {
      location: "",
    };

    setLoading(true);

    LeaveHistoryService.getEmpInfo(payload)
      .then((resp) => {
        setLoading(false);
        setMembers(resp.data);
        // let arr1 = resp.data;
        // CommonService.getEmpBasicInfoByLoc(payload2)
        //   .then((resp) => {
        //     let arr2 = resp.data;
        //     //console.log(arr1, arr2)
        //     const mergedArr = arr1.map((item) => {
        //       const match = arr2.find((row) => row.empId === item.empId);
        //       return { ...item, ...match };
        //     });
        //     //  console.log(mergedArr)
        //     setMembers(mergedArr);
        //   })
        //   .catch((e) => console.log(e));
      })
      .catch((e) => console.log(e));
  };

  const fetchTeamMembers = useCallback(() => {
    const payload = {
      managerid: user.role === "2" ? user.empid : "",
    };
    setLoading(true);

    LeaveHistoryService.getRmteam(payload)
      .then((resp) => {
        if (resp.data) {
          setLoading(false);
          setMembers(resp.data);
        }
      })
      .catch((e) => console.log(e));
  }, [user]);

  useEffect(() => {
    if (user.role === "1" || user.role === "4") {
      fetchAllEmployees();
    } else {
      fetchTeamMembers();
    }
  }, [user, fetchTeamMembers]);

  const showFilter = (e) => {
    e.preventDefault();
    setFilterBy(true);
  };

    const columnsNew = [
    {
      title: "Emp Id",
      dataIndex: "empid",
      key: "empid",
      hidden: true,
    },
    {
      title: "Emp Name",
      dataIndex: "name",
      key: "name",
      render: (text, row) => {
        const empID = user.role === "2" ? row.empid : row.empId;
        const isProbation =
          user.role === "2" ? row.probation : row.isprobationsts;
        return (
          <div className="emp-info">
            <span>
              <img
                src={isProbation === "0" ? FullTimeCircle : ProbationCircle}
                alt=""
              />
            </span>
            <div className="flex-column">
              <span>{row.name}</span>
              <span className="code">ID: {empID}</span>
            </div>
          </div>
        );
      },
      width: 250,
      fixed: "left",
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      render: (text) => <span title={text}>{text}</span>,
      width: 250,
    },
    {
      title: "RM",
      dataIndex: "rmName",
      key: "rmName",
      render: (text) => <span title={text}>{text}</span>,
      hidden: user.role === "2",
      width: 150,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: (text) => <span title={text}>{text}</span>,
      width: 150,
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      render: (text) => <span title={text}>{text}</span>,
      width: 150,
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      render: (text) => <span title={text}>{text}</span>,
      width: 150,
    },
    {
      title: "Date of Birth",
      dataIndex: "dob",
      key: "dob",
      render: (text) => (
        <span title={text}>
          {text && text !== "" && (
            <>{moment(text, "YYYY-MM-DD").format("D MMM YYYY")}</>
          )}
        </span>
      ),
      width: 120,
    },
    {
      title: "Joining Date",
      dataIndex: "joiningdate",
      key: "joiningdate",
      render: (text) => (
        <span title={text}>
          {text && text !== "" && (
            <>{moment(text, "YYYY-MM-DD").format("D MMM YYYY")}</>
          )}
        </span>
      ),
      width: 120,
    },
    {
      title: "Confirmation Date",
      dataIndex: "comfirmation_date",
      key: "comfirmation_date",
      render: (text) => (
        <span title={text}>
          {text && text !== "" && (
            <>{moment(text, "YYYY-MM-DD").format("D MMM YYYY")}</>
          )}
        </span>
      ),
      width: 140,
    },
    {
      title: "Phone",
      dataIndex: "mobileno",
      key: "mobileno",
      render: (text) => (
        <span title={text ? text : "----"}>{text ? text : "----"}</span>
      ),
      width: 110,
    },
    {
      title: "Quarterly Balance Leaves",
      dataIndex: "queterlyBalanceLeave",
      key: "queterlyBalanceLeave",
      render: (text) => (
        <span title={text}>{text !== undefined ? text : "----"}</span>
      ),
      width: 170,
    },
    {
      title: "Yearly Balance Leaves",
      dataIndex: "yearlyBalanceLeave",
      key: "yearlyBalanceLeave",
      render: (text) => (
        <span title={text}>{text !== undefined ? text : "----"}</span>
      ),
      width: 170,
    },
    {
      title: "Action",
      key: "action",
      render: (text, row) => (
        <div className="action">
          <span>
            <Link
              to={"/empLeaveHistory"}
              state={{
                rowData: row,
                redirectBack:
                  user.role === "1" || user.role === "4"
                    ? "/employees"
                    : "/team",
              }}
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.25 13C16.25 14.795 14.7949 16.25 13 16.25C11.2051 16.25 9.75 14.795 9.75 13C9.75 11.205 11.2051 9.75 13 9.75C14.7949 9.75 16.25 11.205 16.25 13Z"
                  stroke="#6E6284"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.0015 5.41675C8.15067 5.41675 4.04453 8.60487 2.66406 13.0001C4.04451 17.3953 8.15067 20.5834 13.0015 20.5834C17.8522 20.5834 21.9584 17.3953 23.3389 13.0001C21.9584 8.6049 17.8522 5.41675 13.0015 5.41675Z"
                  stroke="#6E6284"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </span>
        </div>
      ),
      width: 80,
      fixed: "right",
    },
]

  const columns = [
    {
      name: "Emp Id",
      selector: (row) => (user.role === "2" ? row.empid : row.empId),
      omit: true,
    },
    {
      name: "Emp Name",
      selector: (row) => row.name,
      cell: (row) => {
        const empID = user.role === "2" ? row.empid : row.empId;
        const isProbation =
          user.role === "2" ? row.probation : row.isprobationsts;
        return (
          <>
            <div className="emp-info">
              <span>
                <img
                  src={isProbation === "0" ? FullTimeCircle : ProbationCircle}
                  alt=""
                />
              </span>
              {/* <span>
                {row.empProfilePicName !== "" ? (
                  <>
                    <div className="p-circle2">
                      <img
                        src={`https://elmsbk.aeontechhub.com/ProfilePic/${row.empId}/${row.empProfilePicName}`}
                        width="25px"
                        alt=""
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {row.gender === "Male" ? (
                      <>
                        <div className="p-circle2">
                          <img
                            src="https://avatar.iran.liara.run/public/boy"
                            width="25px"
                            alt=""
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="p-circle2">
                          <img
                            src="https://avatar.iran.liara.run/public/girl"
                            width="25px"
                            alt=""
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
              </span> */}
              <div className="flex-column">
                <span>{row.name}</span>
                <span className="code">ID: {empID}</span>
              </div>
            </div>
          </>
        );
      },
      sortable: true,
      width: "250px",
    },
    {
      name: "Email ID",
      selector: (row) => row.email,
      cell: (row) => (
        <>
          <span title={`${row.email}`}>{`${row.email}`}</span>
        </>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "RM",
      selector: (row) => row.rmName,
      cell: (row) => (
        <>
          <span title={`${row.rmName}`}>{`${row.rmName}`}</span>
        </>
      ),
      sortable: true,
      omit: user.role === "2",
      width: "150px",
    },
    {
      name: "Location",
      selector: (row) => row.location,
      cell: (row) => (
        <>
          <span title={`${row.location}`}>{`${row.location}`}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Department",
      selector: (row) => row.department,
      cell: (row) => (
        <>
          <span title={`${row.department}`}>{`${row.department}`}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Designation",
      selector: (row) => row.designation,
      cell: (row) => (
        <>
          <span title={`${row.designation}`}>{`${row.designation}`}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Date of Birth",
      selector: (row) => row.dob,
      cell: (row) => (
        <>
          <span title={`${row.dob}`}>
            {row.dob !== "" && (
              <>{moment(row.dob, "YYYY-MM-DD").format("D MMM YYYY")}</>
            )}
          </span>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Joining Date",
      selector: (row) => row.joiningdate,
      cell: (row) => (
        <>
          <span title={`${row.joiningdate}`}>
            {row.joiningdate !== "" && (
              <>{moment(row.joiningdate, "YYYY-MM-DD").format("D MMM YYYY")}</>
            )}
          </span>
        </>
      ),
      sortable: true,
       width: "120px",
    },
    {
      name: "Confirmation Date",
      selector: (row) => row.comfirmation_date,
      cell: (row) => (
        <>
          <span title={`${row.comfirmation_date}`}>
            {" "}
            {row.comfirmation_date !== "" && (
              <>
                {moment(row.comfirmation_date, "YYYY-MM-DD").format(
                  "D MMM YYYY"
                )}
              </>
            )}
          </span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Phone",
      selector: (row) => row.mobileno,
      cell: (row) => (
        <>
          <span title={`${row.mobileno ? row.mobileno : "----"}`}>{`${
            row.mobileno ? row.mobileno : "----"
          }`}</span>
        </>
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: "Queterly Balance Leaves",
      selector: (row) => row.yearlyBalanceLeave,
      cell: (row) => (
        <>
          <span title={`${row.queterlyBalanceLeave}`}>{`${
            row.queterlyBalanceLeave !== undefined
              ? row.queterlyBalanceLeave
              : "----"
          }`}</span>
        </>
      ),
      sortable: true,
      width: "170px",
    },
     {
      name: "Yearly Balance Leaves",
      selector: (row) => row.yearlyBalanceLeave,
      cell: (row) => (
        <>
          <span title={`${row.yearlyBalanceLeave}`}>{`${
            row.yearlyBalanceLeave !== undefined
              ? row.yearlyBalanceLeave
              : "----"
          }`}</span>
        </>
      ),
      sortable: true,
       width: "170px",
    },
    {
      name: "Action",
      selector: (row) => row.id,
      cell: (row) => (
        <>
          <div className="action">
            <span>
              <Link
                to={"/empLeaveHistory"}
                state={{
                  rowData: row,
                  redirectBack:
                    user.role === "1" || user.role === "4"
                      ? "/employees"
                      : "/team",
                }}
              >
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.25 13C16.25 14.795 14.7949 16.25 13 16.25C11.2051 16.25 9.75 14.795 9.75 13C9.75 11.205 11.2051 9.75 13 9.75C14.7949 9.75 16.25 11.205 16.25 13Z"
                    stroke="#6E6284"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.0015 5.41675C8.15067 5.41675 4.04453 8.60487 2.66406 13.0001C4.04451 17.3953 8.15067 20.5834 13.0015 20.5834C17.8522 20.5834 21.9584 17.3953 23.3389 13.0001C21.9584 8.6049 17.8522 5.41675 13.0015 5.41675Z"
                    stroke="#6E6284"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </span>
          </div>
        </>
      ),
      omitFromExport: true,
      sortable: true,
    },
  ];

  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearch(e.target.value);
    const filteredData = members.filter(
      (row) =>
        (row.name && row.name.toLowerCase().includes(keyword)) ||
        (row.empid && row.empid.toLowerCase().includes(keyword)) ||
        (row.empId && row.empId.toLowerCase().includes(keyword)) ||
        (row.email && row.email.toLowerCase().includes(keyword))
    );
    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  const handleCheckedChange = (type) => (e) => {
    if (e.target.checked) {
      setChecked(type);
      setDetails((prev) => ({
        ...prev,
        isProbation: type,
      }));
    } else {
      setChecked("");
    }
  };

  const handleFilter = () => {
    let filteredData = members;

    const objectValues = {
      empId: user.role === "1" || user.role === "4" ? details.empId : "",
      empid: user.role === "2" ? details.empId : "",
      email: details.email,
      location: details.location,
      designation: details.designation,
      department: details.department,
      yearlyBalanceLeave:
        details.leaveBalance !== ""
          ? parseFloat(details.leaveBalance).toFixed(2)
          : "",
      isprobationsts: details.isProbation,
    };

    const nonEmptyDetails = Object.fromEntries(
      Object.entries(objectValues).filter(
        ([_, value]) => value !== "" && value !== null
      )
    );

    filteredData = filteredData.filter((item) =>
      Object.entries(nonEmptyDetails).every(([detailsKey, value]) =>
        checked !== ""
          ? item.hrActionsts === checked ||
            item.rmActionsts === checked ||
            item[detailsKey] === value
          : item[detailsKey] === value
      )
    );

    // console.log(nonEmptyDetails, filteredData);

    setFilter(true);
    setFilteredData(filteredData);
    setFilterBy(false);
  };

  const clearFilter = () => {
    setFilter(false);
    setDetails(initialData);
    setChecked("");
    setDate();
    setFilterBy(false);
  };

  const exportToExcel = (e, columns, data, reportName) => {
    const formattedData = data.map((row) => {
      const formattedRow = {};

      columns.forEach((col) => {
        let value;

        if (col.omitFromExport) return;

        // If selector exists
        if (typeof col.selector === "function") {
          value = col.selector(row);

          // Convert JSX / React element to text
          if (col.name === "RM Approval" || col.exportAsText) {
            value =
              row.rmActionsts === "0"
                ? "Pending"
                : row.rmActionsts === "1"
                ? "Approved"
                : "Rejected";
          }
        } else {
          value = row[col.name];
        }

        formattedRow[col.name] = value;
      });

      return formattedRow;
    });

    const fileName = filter ? "" : "";

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${reportName}.xlsx`);
  };

  return (
    <>
      <div className="dashboard-container hr">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div className="filterBarNew mb-3">
          <div className="d-flex">
            <div className="searchBar">
              <input
                type="text"
                placeholder="Search Employee name/ID/Email"
                value={search}
                onChange={handleSearch}
              />
              <span>
                <img src={SearchIcon} alt="" />
              </span>
            </div>
          </div>

          <div className="filterBar filter topbar">
            <div className="action">
              {user.role === "1" && (
                <>
                  <Link
                    to={"/addemployee"}
                    state={{ redirectBack: "/employees" }}
                  >
                    <button className="apply">
                      <span>Add New</span>
                    </button>
                  </Link>

                  <button
                    className="apply"
                    onClick={(e) => {
                      setUploadModal(true);
                    }}
                  >
                    <span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5535 2.49392C12.4114 2.33852 12.2106 2.25 12 2.25C11.7894 2.25 11.5886 2.33852 11.4465 2.49392L7.44649 6.86892C7.16699 7.17462 7.18823 7.64902 7.49393 7.92852C7.79964 8.20802 8.27403 8.18678 8.55353 7.88108L11.25 4.9318V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V4.9318L15.4465 7.88108C15.726 8.18678 16.2004 8.20802 16.5061 7.92852C16.8118 7.64902 16.833 7.17462 16.5535 6.86892L12.5535 2.49392Z"
                          fill="#ffffff"
                        />
                        <path
                          d="M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z"
                          fill="#ffffff"
                        />
                      </svg>
                    </span>
                    <span>Upload</span>
                  </button>
                </>
              )}
            </div>
            <div className="sort-filter filter">
              <div className="filter" onClick={showFilter}>
                <img src={FilterIcon} alt="" />
              </div>
              <div
                className="export"
                onClick={(e) => {
                  exportToExcel(
                    e,
                    columns,
                    filter ? filteredData : members,
                    "Employees List",
                  );
                }}
              >
                <span>
                  <img src={ExportIcon} alt="" />
                </span>
                <span>Export</span>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <div style={{ position: "relative", zIndex: 0 }}>
          <Table
            loading={loading}
            dataSource={filter ? filteredData : members}
            columns={columnsNew}
            showSorterTooltip={{ target: "sorter-icon" }}
            scroll={{ x: "max-content" }}
            //   size="small"
          />
        </div>

        {/* <DataTableComponent
          columns={columns}
          data={filter ? filteredData : members}
        /> */}

        <div
          className={`${showCalendar ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShowCalendar(false);
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          ></div>
        </div>

        <div
          className={`${filterBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFilterBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <EmployeeFilterModal
              user={user}
              data={members}
              details={details}
              setDetails={setDetails}
              date={date}
              setDate={setDate}
              checked={checked}
              handleCheckedChange={handleCheckedChange}
              handleFilter={handleFilter}
              clearFilter={clearFilter}
            />
          </div>
        </div>

        <div
          className={`${uploadModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setUploadModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <UploadEmployee
              uploadModal={uploadModal}
              setUploadModal={setUploadModal}
            />
          </div>
        </div>

        {/* <div
          className={`${newEmployeeModal ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setNewEmployeeModal(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <AddNewEmployee
              newEmployeeModal={newEmployeeModal}
              setNewEmployeeModal={setNewEmployeeModal}
              members={members}
            />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Employees;
